var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.toTopVisible)?_c('button',{staticStyle:{"position":"fixed","bottom":"50px","right":"50px","background-color":"#be1a42","padding":"10px 15px","border-radius":"15px","color":"wheat"},attrs:{"id":"my-button"},on:{"click":_vm.toTop}},[_vm._v(" ↑ Arriba ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }